import { seriesHomePath } from '@qcwp/common'
import { removeElementTags } from '@qcwp/utils'
import { useCarStore } from '~/store/car'
import type { ArticleCarRefVO } from '~~/src/server/modules/article/type'
/**
 * @deprecated
 */
export async function preDataGetHandler() {
  const carStore = useCarStore()
  await carStore.getSeriesAllMap()
}

// export function matchCarIndexOf(data: string) {
//   const carStore = useCarStore()
//   const { seriesPatternMap } = storeToRefs(carStore)
//   if (!seriesPatternMap.value.size)
//     return []
//   // console.log('seriesPatternMap', seriesPatternMap.value)
//   const content = removeElementTags(data)
//   // [id, seriesName, index]
//   const results: [string, string, number][] = []

//   // console.log('len', content.length)
//   for (const [name, id] of seriesPatternMap.value) {
//     // console.log('series', key, value)
//     const index = content.indexOf(name)
//     if (index !== -1)
//       results.push([id, name, index])
//   }

//   return results
// }

export function createPattern(carSeriesName: string, brandName: string): string[] {
  const newPattern: string[] = []
  brandName = brandName.replace(/(汽车|新能源)/, '')

  if (
    ((carSeriesName.match(/^[a-zA-Z0-9]+/) && carSeriesName.length < 6)
    || (!carSeriesName.match(/^[a-zA-Z0-9]+$/) && carSeriesName.length <= 2))
    && brandName
  )
    newPattern.push(`${brandName}${carSeriesName}`)
  else
    newPattern.push(carSeriesName)

  if (carSeriesName.match(/级$/)) {
    const seriesName = carSeriesName.replace(/级$/, '')
    newPattern.push(`${brandName}${seriesName}`)
    carSeriesName.length > 6 && newPattern.push(seriesName)
  }

  return newPattern
}

export function matchCarIndexOf(data: string, cars: ArticleCarRefVO[]): [string, string, number][] {
  if (!cars.length)
    return []

  // [id, seriesName, index]
  const results: [string, string, number][] = []
  const matchSeriesName = new Map<string, string>() // name id
  cars.forEach((item) => {
    const { carBrandName, carVendorName, carSeriesName, carSeriesId } = item

    if (!carSeriesName)
      return
    createPattern(carSeriesName, carBrandName).forEach((name) => {
      matchSeriesName.set(name, carSeriesId)
    })

    if (carBrandName !== carVendorName) {
      createPattern(carSeriesName, carVendorName).forEach((name) => {
        matchSeriesName.set(name, carSeriesId)
      })
    }
  })
  const content = removeElementTags(data)
  for (const [name, id] of matchSeriesName) {
    // console.log('series', key, value)
    const index = content.indexOf(name)
    if (index !== -1)
      results.push([id, name, index])
  }
  // console.log('matchSeriesName', matchSeriesName, results)
  return results
}
export function replaceCar(data: string, results: [string, string, number][]): string {
  let content = data
  if (!results.length)
    return content

  results = results.sort(([_, a], [__, b]) => b.length - a.length)
  const allSeriesName = results.map(([_, seriesName]) => seriesName)

  // 排序先替换长的
  results.sort(([_, a], [__, b]) => b.length - a.length).forEach(([key, value]) => {
    const seriesName = value
    if (seriesName) {
      content = `${content.replace(new RegExp(seriesName, 'g'), (substring: string, index: number, content: string) => {
        // console.log('substring', substring, content[index])
        // 忽略标签内的替换eg.比亚迪 => <div alt="比亚迪">
        const isInclude = allSeriesName.some(item => checkIsIncludesSubString(seriesName, item, index, content))
        // console.log('isInclude', isInclude, substring, '|', seriesName, '|', content.slice(index, index + 15))
        if (patternIsTagAttribute(content, index) || isInclude)
          return substring

        return `<a href="${seriesHomePath(key)}" target="_blank">${seriesName}</a>`
      })}`
    }
  })

  return content
}

function patternIsTagAttribute(content: string, index: number): boolean {
  let leftIndex = -1
  let rightIndex = -1
  for (let i = index; i >= 0; i--) {
    if (content[i] === '<') {
      leftIndex = i
      break
    }
    else if (content[i] === '>') {
      break
    }
  }
  for (let i = index; i < content.length; i++) {
    if (content[i] === '>') {
      rightIndex = i
      break
    }
    else if (content[i] === '<') {
      break
    }
  }

  return leftIndex !== -1 && rightIndex !== -1
}

/**
 *
 * @param value 要匹配的字符串
 * @param pattern 包含 **要匹配的字符串** 的 **另一个匹配字符串**
 * @param index 要匹配的字符串在原始字符串中的索引
 * @param content 原始字符串
 */
function checkIsIncludesSubString(value: string, pattern: string, index: number, content: string): boolean {
  if (!pattern.includes(value))
    return false

  const leftPatternIndex = index - pattern.indexOf(value)
  const rightPatternIndex = leftPatternIndex + pattern.length - 1
  if (content[leftPatternIndex - 1] === '>' && content[rightPatternIndex + 1] === '<')
    return true

  return false
}
